// src/Components/LoginComponents/UnauthorizedPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./UnauthorizedPage.css";
import ugaaLogo from "../../Assets/images/logo-rmbg.png"; // Alumni Logo

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/admin-panel/auth/login");
  };

  return (
    <div className="unauthorized-page">
      {/* Background overlay */}
      <div className="unauthorized-overlay"></div>

      <div className="unauthorized-content">
        <img src={ugaaLogo} alt="UGAA Logo" className="unauthorized-logo" />
        <h1>Access Denied</h1>
        <p>
          You do not have permission to access this page.
        </p>
        <button onClick={handleGoBack} className="unauthorized-btn">
          Go Back to Login
        </button>
      </div>
    </div>
  );
}
